import { useEffect, useState } from "react";

const navLinks = [
  { href: "#latest", label: "今日更新" },
  { href: "#topics", label: "话题墙" },
  { href: "#perks", label: "会员特权" },
  { href: "#collections", label: "精选专题" },
  { href: "#buzz", label: "热评互动" },
  { href: "#plans", label: "会员方案" },
];

export default function SiteHeader() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`sticky top-0 z-40 w-full border-b transition-colors duration-300 ${
        scrolled
          ? "border-background-200 bg-background-50/95 backdrop-blur"
          : "border-transparent bg-background-50"
      }`}
    >
      <div className="mx-auto flex h-16 w-full items-center justify-between px-4 md:h-[72px] md:px-8">
        <a href="#top" className="flex items-center gap-3">
          <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-500 text-background-50">
            <i className="ri-vip-diamond-fill text-xl" />
          </span>
          <span className="flex flex-col leading-tight">
            <span className="font-heading text-lg font-bold tracking-wide text-foreground-950 md:text-xl">
              黑料福利
            </span>
            <span className="text-[11px] tracking-[0.2em] text-secondary-600">HEILIAO CLUB</span>
          </span>
        </a>

        <nav className="hidden items-center gap-1 lg:flex">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="whitespace-nowrap rounded-md px-3 py-2 text-sm text-foreground-700 transition-colors hover:bg-background-100 hover:text-primary-600"
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a
            href="#plans"
            className="hidden whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 sm:flex"
          >
            开通会员
          </a>
          <button
            type="button"
            aria-label="打开导航"
            onClick={() => setMenuOpen((prev) => !prev)}
            className="flex h-10 w-10 items-center justify-center rounded-md border border-background-300 text-foreground-800 transition-colors hover:bg-background-100 lg:hidden"
          >
            <i className={menuOpen ? "ri-close-line text-xl" : "ri-menu-line text-xl"} />
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="border-t border-background-200 bg-background-50 lg:hidden">
          <nav className="mx-auto flex w-full flex-col px-4 py-3 md:px-8">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setMenuOpen(false)}
                className="flex items-center justify-between border-b border-background-100 py-3 text-sm text-foreground-800 last:border-0"
              >
                {link.label}
                <i className="ri-arrow-right-s-line text-secondary-500" />
              </a>
            ))}
            <a
              href="#plans"
              onClick={() => setMenuOpen(false)}
              className="mt-3 flex items-center justify-center rounded-md bg-primary-500 px-4 py-3 text-sm font-medium text-background-50"
            >
              开通会员
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}